import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface IGenericError {
  errorMessage: string;
}


export interface IError extends IGenericError {
  origin: string;
}


@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private currentError: string = "";
  private origin: string = "/authenticate";

  constructor(private router: Router) { }

  setCurrentError(error: string, origin: string = "/") {
    this.currentError = error;
    this.origin = origin;
  }

  getCurrentError() {
    return this.currentError;
  }

  getErrorOrigin(): string {
    return this.origin;
  }

  setCurrentOrigin(origin: string) {
    this.origin = origin;
  }

  getError(): IError {
    const error: IError = {
      errorMessage: this.currentError,
      origin: this.origin
    }

    return error;
  }

  navigateToErrorPage(errorMessage?: string, errorOrigin: string = window.location.origin + window.location.pathname) {
    if (errorOrigin) {
      this.origin = errorOrigin;
    }

    if(errorMessage) {
      this.currentError = errorMessage;
    }

    return this.router.navigate(['/error']);
  }
 }
